<template>
  <div class="mood-picker">
    <button
      v-for="m in moods" :key="m.emoji" type="button"
      class="mood-btn" :class="{ active: value === m.emoji }"
      @click="$emit('input', value === m.emoji ? null : m.emoji)"
    >
      <span class="emoji">{{ m.emoji }}</span>
      <span class="label">{{ m.label }}</span>
    </button>
  </div>
</template>

<script>
export const MOODS = [
  { emoji: '😍', label: '超讚' },
  { emoji: '😊', label: '開心' },
  { emoji: '😌', label: '平靜' },
  { emoji: '😴', label: '累' },
  { emoji: '😵', label: '混亂' },
  { emoji: '😢', label: '難過' },
  { emoji: '🤯', label: '意外' },
  { emoji: '❤️', label: '特別' }
]

export default {
  name: 'MoodPicker',
  props: {
    value: { type: String, default: null }
  },
  data () {
    return { moods: MOODS }
  }
}
</script>

<style scoped>
.mood-picker {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.mood-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 58px;
  padding: 8px 2px;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: #fff;
}
.mood-btn.active {
  border-color: var(--color-primary);
  background: #fff5f0;
}
.emoji { font-size: 20px; }
.label { font-size: 10px; color: var(--color-text-dim); }
</style>
